import { render, staticRenderFns } from "./editInTeam.vue?vue&type=template&id=4c37045c&"
import script from "./editInTeam.vue?vue&type=script&lang=js&"
export * from "./editInTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports